import entity from '../../../models/loads/drivers'

export default [
  {
    path: '/drivers',
    meta: {
      entity,
      requiresPermissionTo: 'drivers',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/drivers/new',
    meta: {
      entity,
      requiresPermissionTo: 'drivers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/drivers/:id',
    meta: {
      entity,
      requiresPermissionTo: 'drivers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
